import { v4 as uuid } from 'uuid';

import { MESSAGES, ROLE } from '../../../constants';

export interface ISurvey {
  readonly id: string;
  readonly type: MESSAGES.SURVEY;
  readonly surveyUrl: string;
  readonly role: ROLE.BOT;
  readonly rm: false;
  readonly avatar: boolean;
}

export const createSurvey = (data: Record<string, unknown>): ISurvey => ({
  id: (data.id as string) || uuid(),
  type: MESSAGES.SURVEY,
  surveyUrl: (data.surveyUrl as string) ?? '',
  role: ROLE.BOT,
  rm: false,
  avatar: true,
});
